import { AxiosResponse } from 'axios';
import { User } from 'oidc-client';
import { publicRoutes } from '../routes/appRouteList';
import Authenticator from './authenticator';

interface AuthService {
    getUser: Function;
    login: Function;
    loginCallback: Function;
    logout: Function;
    authorize: Function;
    getAccessToken: Function;
}

const AuthService = ((): AuthService => {
    let user: any | null = null;

    const isBlank = (value: string | null | undefined): boolean => {
        return !(value !== '' && value !== null && value !== undefined);
    };

    const isUserPresent = (): boolean | '' => {
        return !isBlank(user);
    };

    const getUser = (): Promise<any | null> => {
        if (Authenticator.isAuthenticated()) {
            if (isUserPresent()) {
                return new Promise((resolve): void => {
                    resolve(user);
                });
            }

            return Authenticator.getUserInfo().then((userObj: User) => {
                user = userObj;
                return user;
            });
        }

        return new Promise((_, reject): void => {
            reject();
        });
    };

    const login = (props: any): void => {
        return Authenticator.authenticator(props, publicRoutes.authorize);
    };

    const logout = async (): Promise<void> => {
        await Authenticator.signOut();
    };

    const loginCallback = (props: any): void => {
        return Authenticator.fetchAccessToken(props, publicRoutes.authorize);
    };

    const authorize = (): Promise<AxiosResponse> => {
        return Authenticator.updateUserLoggedIn();
    };

    const getAccessToken = (): void => {
        return Authenticator.getAccessToken();
    };

    return {
        getUser,
        login,
        loginCallback,
        logout,
        authorize,
        getAccessToken
    };
})();

export default AuthService;
